import React, { PureComponent } from 'react';
const PropTypes = require('prop-types');
import { formatText } from 'core/i18n';
const classNames = require('classnames');

class PasswordRequirement extends PureComponent {
    constructor(props) {
        super(props);
    }
    render() {
        const { showShakeAnimationOnPasswordError, errorPassAscDesc, errorPassEquals, errorPassBirthDay } = this.props;
        const hiddenPasswordRequirements = classNames('password-requirements requirement-box', {
            'prospects-animation prospects-animation--shake': showShakeAnimationOnPasswordError,
        });
        return (
            <div className={hiddenPasswordRequirements}>
                <h6 className="font-heading6">{formatText('field-Requirements')}</h6>
                <ul>
                    <li className={errorPassAscDesc ? 'requirement-fail' : undefined}>
                        {formatText('field-passAscDesc')}
                    </li>
                    <li className={errorPassEquals ? 'requirement-fail' : undefined}>
                        {formatText('field-passEquals')}
                    </li>
                    <li className={errorPassBirthDay ? 'requirement-fail' : undefined}>
                        {formatText('field-passBirthYear')}
                    </li>
                </ul>
            </div>
        );
    }
}

PasswordRequirement.propTypes = {
    errorPassAscDesc: PropTypes.bool,
    errorPassEquals: PropTypes.bool,
    errorPassBirthDay: PropTypes.bool,
    showShakeAnimationOnPasswordError: PropTypes.bool,
};

PasswordRequirement.defaultProps = {
    errorPassAscDesc: false,
    errorPassEquals: false,
    errorPassBirthDay: false,
    showShakeAnimationOnPasswordError: false,
};

export default PasswordRequirement;
